import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import {map, Observable, tap} from 'rxjs';
import {EmployeeService} from '../services/employee.service';
import {IDropdownObject} from '../interfaces/dropdown-object.interface';
import {EmployeeStatuses} from '../interfaces/roles.interace';
import {AccessManagementService} from '../services/access-management.service';

@Injectable({
  providedIn: 'root',
})
export class CheckPendingStatusGuard  {
  constructor(
    private employeeService: EmployeeService,
    private access: AccessManagementService,
    private router: Router
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const statusOfEmployee = this.access.statusOfEmployee.value;
    const employeeId = +route.parent!.params['id'];

    if (!employeeId) {
      return this.navigateOut();
    }

    if (statusOfEmployee && statusOfEmployee.employeeId === employeeId) {
      return this.checkAndNavigate(statusOfEmployee.status);
    }

    return this.employeeService.getEmployeeStatus(employeeId).pipe(
      tap(status =>
        this.access.statusOfEmployee.next({employeeId, status: status.name})
      ),
      map((status: IDropdownObject) => this.isPending(status.name)),
      tap((isPending: boolean) => {
        if (!isPending) this.navigateOut();
      })
    );
  }

  private checkAndNavigate(status: string): boolean {
    return !this.isPending(status) ? this.navigateOut() : true;
  }

  private navigateOut(): boolean {
    this.router.navigateByUrl('');
    return false;
  }

  private isPending(status: string): boolean {
    return status === EmployeeStatuses.Pending;
  }
}
